import { isWithin } from "./time";
import moment from "moment";

export const getCodeStatus = (code) => {
  if (isWithin(code?.time?.collect)) {
    return "ongoing";
  }
  return moment().isAfter(code?.time?.collect?.end) ? "expired" : "pending";
};

export const formatProductWithAvailableQty = (product, codes = []) => {
  if (!product || !product.id || !product.qty) {
    throw new Error("Invalid product object provided");
  }

  // Set default value for promotionCode if it is undefined or 0
  const promotionCodeQty = product.qty.promotionCode || 0;

  // Flatten `products` from each code and filter by the matching `product.id`
  const totalCodeQty = codes.reduce((acc, code) => {
    const matchingItems = code.products.filter((item) => item.id === product.id);
    const totalQtyForProduct = matchingItems.reduce((sum, item) => sum + item.qtyPerCollection * code.qty, 0);
    return acc + totalQtyForProduct;
  }, 0);

  // Calculate available quantity
  const availableQty = promotionCodeQty - totalCodeQty;

  return {
    ...product,
    qty: {
      ...product.qty,
      available: Math.max(availableQty, 0), // Ensure available qty is non-negative
    },
  };
};
